var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Card',[_c('tables',{ref:"tables",attrs:{"editable":"","searchable":"","search-place":"top","columns":_vm.columns},on:{"on-delete":_vm.handleDelete},model:{value:(_vm.tableData),callback:function ($$v) {_vm.tableData=$$v},expression:"tableData"}}),_c('Pager',{attrs:{"total":this.total},on:{"on-page-change":_vm.onPageChange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }